/**
 * Меню довідки «?» (UX-39; onboarding-help.md): у верхній панелі на кожному екрані, в тому самому
 * місці перед меню користувача (WCAG 3.2.6). Пункти — «Гарячі клавіші» (`?`, UX-12), «Повідомити
 * про проблему» (UX-51), «Регламенти компанії» і версія збірки — у лінивому `help-items.ts`: перший
 * екран бере лише кнопку (#1244). Модуль не прийшов — меню закривається, тост просить ще раз.
 * Статей довідки Clientline і команди палітри «Довідка» ще немає (Next).
 */
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { shell as t } from '../i18n/uk/shell.ts';
import { MenuButton } from '../ui/Menu.tsx';
import { toast } from '../ui/notify/store.ts';

type HelpItems = typeof import('./help-items.ts')['helpItems'];
let loaded: HelpItems | null = null;
let helpModule: Promise<HelpItems> | null = null;
/** Модуль пунктів — один на вкладку; збій не запам'ятовуємо: наступне відкриття вантажить знову. */
function loadHelpItems(): Promise<HelpItems> {
  helpModule ??= import('./help-items.ts').then(
    (m) => (loaded = m.helpItems),
    (error: unknown) => {
      helpModule = null;
      throw error;
    },
  );
  return helpModule;
}

export function HelpMenu() {
  const client = useQueryClient();
  const [fill, setFill] = useState<HelpItems | null>(() => loaded);
  return (
    <MenuButton
      label={t.help}
      title={t.help}
      items={() => fill?.(client) ?? null}
      onOpen={() => loadHelpItems().then((fn) => setFill(() => fn))}
      onOpenFailed={() => toast({ key: 'help-menu-failed', text: t.helpFailed, tone: 'alert' })}
      className="btn btn--ghost btn--icon topbar__help"
    >
      <span aria-hidden="true">?</span>
    </MenuButton>
  );
}
